<section class="section about" id="about" aria-label="about">
	<div class="container">
		<h2 class="section-title">SKIING</h2>

		<p class="section-text">
			A bit about Skiing, Skiing is a fictional company that sells snowboards and
			snowboard accessories.
		</p>

		<iframe
			width="560"
			height="315"
			src="https://www.youtube.com/embed/t705_V-RDcQ"
			title="YouTube video player"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			allowfullscreen
		/>
	</div>
</section>

<style>
	.about {
		padding-top: 100px;
        margin: auto 0;
        
        text-align: center;
	}
    .section-title {
        margin-bottom: 20px;
        font-size: 34px;
    }
    .section-text {
        margin-block: 12px 45px;
    }
</style>